import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "@reach/router";
import "react-spinning-wheel/dist/style.css";
import { BasicLayout } from "layouts";
import { navigate } from "@reach/router";
import {
  ProfileCityState,
  ProfileGender,
  ProfileInput,
	ProfileMultiInput,
  ProfileDatePicker,
} from "components";
import { useAuthContext } from "contexts/Auth";
import { CustomerRewardTable } from "components/CustomerRewardTable";
import { ICustomer } from "types";
import { FaArrowLeft } from "react-icons/fa";
import { getCustomer, updateBulkCustomer,getPrivacyPreferenceCustomer,updatePrivacyPreferenceCustomer } from "api";
import { useNotifications } from "reapop";
import "./style.scss";
import { ProfileCust } from "components/ProfileCust";
import { Card } from "components/Card";
import { EmailSelect } from "components/EmailSelect";
import { PhoneSelect } from "components/PhoneSelect";


interface ICard {
  id: number;
  account_no: string;
  open_date: string;
  tier_status: string;
  card_status: string;
}

type props = {
  onCheckChanged: (checked: boolean) => void; // Callback when checkbox is toggled
};

export const EditProfilePage: React.FunctionComponent<RouteComponentProps> = (
  props: any
) => {  
  const { notify } = useNotifications();
  const { sec_permissions } = useAuthContext();
  const [cards, setCards] = useState<ICard[]>([]);
  const [totalPages, setTotalPages] = useState<number>(200);
  const [page, setPage] = useState<number>(1);
  const [updating, setUpdating] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(false);
  // get data from props
  const [customer, setCustomer] = useState<ICustomer>(props.location?.state?.data);
  const [rawCustomer, setRawCustomer] = useState<Array<any>>([]);
  // PII, Marketing, CCPA
  const [isPII, setIsPII] = useState(false); // useState(updating ? false : sec_permissions.includes("Update PII"));
  // const [isSyncronyCcommerce, setIsSyncronyCcommerce] = useState(false);
  const isMarketing = updating
    ? false
    : sec_permissions.includes("Update Marketing Flags");
  const [isCCPA, setIsCCPA] = useState(false);
  // Personal Information
  const [firstName, setFirstName] = useState<string>("");
  const [middleName, setMiddleName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [address1, setAddress1] = useState<string>("");
  const [address2, setAddress2] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [sourceEmail, setSourceEmail] = useState<string>("");
  const [sourcePrimaryPhone, setSourcePrimaryPhone] = useState<string>("");
  const [birthDate, setBirthDate] = useState<Date>('' as any);
  const [status, setStatus] = useState<string>("Good");
  const [identificationId, setIdentificationId] = useState<string>("");
  const [hhId, setHHId] = useState<string>("");
  const [hhHead, setHeadOfHH] = useState<string>("");
  const [gender, setGender] = useState<string>("Not specified");
  const [employeeId, setEmployeeId] = useState<string>("");
  // Contact Preferences
  const [contactDirectMail, setContactDirectMail] = useState<string>("N");
  const [contactDirectMailUpdatedAt, setContactDirectMailUpdatedAt] = useState<Date>('' as any);
  const [contactEmail, setContactEmail] = useState<string>("N");
  const [contactEmailUpdatedAt, setContactEmailUpdatedAt] = useState<Date>('' as any);
  const [contactPhoneCall, setContactPhoneCall] = useState<string>("N");
  const [contactPhoneCallUpdatedAt, setContactPhoneCallUpdatedAt] = useState<Date>('' as any);
  const [contactPhoneText, setContactPhoneText] = useState<string>("");
  const [contactPhoneTextUpdatedAt, setContactPhoneTextUpdatedAt] = useState<Date>('' as any);
  const [contactFragrance, setContactFragrance] = useState<string>("N");
  const [contactFragranceOptionUpdatedAt, setContactFragranceOptionUpdatedAt] = useState<Date>('' as any);
  // CCPA
  const [ccpaRightToOptout, setCCPARightToOptout] = useState<string>("N");
  const [ccpaRightToOptoutUpdatedAt, setCCPARightToOptoutUpdatedAt] = useState<Date>('' as any);
  const [ccpaRightToDelete, setCCPARightToDelete] = useState<string>("N");
  const [ccpaRightToDeleteUpdatedAt, setCCPARightToDeleteUpdatedAt] = useState<Date>('' as any);
  const [ccpaRightToKnow, setCCPARightToKnow] = useState<string>("N");
  const [ccpaRightToKnowUpdatedAt, setCCPARightToKnowUpdatedAt] = useState<Date>('' as any);
  const [synchronyCustId, setSynchronyCustId] = useState(false);
  const [ecommerceCustId, setEcommerceCustId] = useState(false);
  const config = localStorage.getItem("config") ? JSON.parse(localStorage.getItem("config") as string) : {};

  //Clienteling
  const [csOptinClientelingTexts, setClientelingTextsToOptout] = useState<string>("N");
  const [csOptinClientelingTextsUpdatedAt, setClientelingTextsUpdatedAt] = useState<Date>('' as any);
  const [csOptinClientelingEmails, setClientelingEmailToOptout] = useState<string>("N");
  const [csOptinClientelingEmailsUpdatedAt, setClientelingEmailUpdatedAt] = useState<Date>('' as any);
  const [csOptinClientelingExclusion, setClientelingExclusionToOptout] = useState<string>("N");
  const [csOptinClientelingExclusionUpdatedAt, setClientelingExclusionUpdatedAt] = useState<Date>('' as any);

  //Privacy Preferences Admin - Begin
  const userDetail = localStorage.getItem('user_details');
  const storedUser = localStorage.getItem('user_permissions');
  const [getPrivacyPreference, setPrivacyPreference] = useState<any>(null);
  const [isCCPAAdmin, setIsCCPAAdmin] = useState(false);
  const [isCCPAAdminChecked, setIsCCPAAdminChecked] = useState(false);
  const hideModifiedDetails = useState(false);
  const [freshServiceTicketNo, setFreshServiceTicketNo] = useState<string>("");
  const [ccpaAdminModifiedBy,setModifiedBy] = useState<string>("");
  const [ccpaAdminModefiedDate, setModifiedDate]=useState<string>("");
  const today = new Date();
  const [error, setError] = useState<string>('');
  const [isValid, setIsValid] = useState<boolean>(true);
  const privacyPreferenceCustomer = [
    customer.mastercustomerid,
    isCCPAAdminChecked,
    freshServiceTicketNo,
    ccpaAdminModifiedBy,
    ccpaAdminModefiedDate
  ];
  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsCCPAAdminChecked(event.target.checked);
    if (userDetail) {
      const parsedUserDetail = JSON.parse(userDetail);
      if(event.target.checked){
        setModifiedBy(`${parsedUserDetail.lastName} ${parsedUserDetail.firstName}`);
        setModifiedDate (today.toLocaleDateString());
      }
      else
      {
        setModifiedBy("");
        setModifiedDate ("");
      }
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFreshServiceTicketNo(event.target.value); // Update SR ticket no state
  };

  useEffect(() => {
    if (isCCPAAdminChecked && freshServiceTicketNo.trim() === "") {
      setIsValid(false); // Set invalid if the ticket number is empty
    } else {
      setIsValid(true); // Set valid if the ticket number is entered
    }
  }, [isCCPAAdminChecked, freshServiceTicketNo]);
  //Privacy Preferences Admin - End
  
  
  const getCustomerDetail = async (customerId) => {
    setFetching(true);

    const res = await getCustomer(customerId).catch(err => {
      notify('There\'s a problem loading customer data.', 'error', {
        title: 'API Error'
      });
    });

    if (res?.data?.result) {
      setRawCustomer(res?.data?.result);
      setCustomer(res?.data?.result[0]);
    }
    

    if (res?.data?.errorCode) {
      notify('There\'s a problem loading customer data.', 'error', {
        title: 'API Error'
      });
    }
    if (customerId) {
      const privacyPreferenceRes = await getPrivacyPreferenceCustomer(customerId); // Await the call here
          
      if (privacyPreferenceRes) {
        setPrivacyPreference(privacyPreferenceRes);
      }
    } else {
      console.error("No valid customerId provided.");
    }
    

    setFetching(false);
  }

  useEffect(() => {
    if (customer) {
      setFirstName(customer?.firstname);
      setMiddleName(customer?.middlename);
      setLastName(customer?.lastname);
      setAddress1(customer?.address1);
      setAddress2(customer?.address2);
      setCity(customer?.city);
      setState(customer?.state);
      setZip(customer?.zipcode);
      setCountry(customer?.country);
      setGender(customer?.gender ? (customer?.gender.toLowerCase() === 'unknown' ? "Not specified" : customer?.gender) : "Not specified");
      setEmployeeId(customer?.mastercustomerid);
      setHHId(customer?.householdid);
      setBirthDate(customer?.birthdate);
      setStatus(customer?.employeecurrentstatus);
      setIdentificationId(customer?.sourcecustomernumber);
    }
  }, [customer]);

  // When either synchronyCustId or ecommerceCustId is truthful
  // set isPII to false to disable all PII input
  useEffect(() => {
    setIsPII(!(synchronyCustId || ecommerceCustId));
  }, [synchronyCustId, ecommerceCustId]);

  useEffect(() => {
    if (rawCustomer.length > 0) {
      const synchronyIds: any[] = rawCustomer.filter((r: any) => r?.sourceofdata?.toLowerCase() === 'synchrony');
      const ecommerceCustIds: any[] = rawCustomer.filter((r: any) => r?.sourceofdata?.toLowerCase()  === 'demandware');

      if (synchronyIds.length > 0) {
        setSynchronyCustId(true);
      }

      if (ecommerceCustIds.length > 0) {
        setEcommerceCustId(true);
      }

      if (sourceEmail) {
        setContactDirectMail(rawCustomer[sourceEmail.split(':')[1]]?.dmoptout);
        setContactDirectMailUpdatedAt(new Date(rawCustomer[sourceEmail.split(':')[1]]?.dmlastupdatedt));
        setContactEmail(rawCustomer[sourceEmail.split(':')[1]]?.donotemail);
        // setContactEmailUpdatedAt(); TBD

        setIsCCPA(config?.ccpa_states?.map(state => state.abbr).includes(rawCustomer[sourceEmail.split(':')[1]]?.state));
      } else {
        // Set default selected email
        setSourceEmail(`${rawCustomer[0].sourceemail}:0`);
      }

      if (sourcePrimaryPhone) {
        setContactPhoneCall(rawCustomer[sourcePrimaryPhone.split(':')[1]]?.calloptout);
        setContactPhoneCallUpdatedAt(new Date(rawCustomer[sourcePrimaryPhone.split(':')[1]]?.calllastupdateddt));
        // setContactPhoneText(); TBD
        // setContactPhoneTextUpdatedAt(); TBD
        setContactFragrance(rawCustomer[sourcePrimaryPhone.split(':')[1]]?.fragranceoptout);
        setContactFragranceOptionUpdatedAt(new Date(rawCustomer[sourcePrimaryPhone.split(':')[1]]?.fragrancelastupdateddt))
      } else {
        // Set default selected phoneNumber
        setSourcePrimaryPhone(`${rawCustomer[0].sourceprimaryphone}:0`);
      }

      setCCPARightToOptout(rawCustomer[0].ccpaoptoutsell);
      setCCPARightToOptoutUpdatedAt(new Date(rawCustomer[0].ccpaoptoutlastupdateddt));
      setCCPARightToDelete(rawCustomer[0].ccpadelete);
      setCCPARightToDeleteUpdatedAt(new Date(rawCustomer[0].ccpadeletelastupdateddt));
      setCCPARightToKnow(rawCustomer[0].ccpaknow);
      setCCPARightToKnowUpdatedAt(new Date(rawCustomer[0].ccpaknowlastupdateddt));

      setClientelingTextsToOptout(rawCustomer[0].csoptinclientelingtexts);
      setClientelingTextsUpdatedAt(new Date(rawCustomer[0].csoptinclientelingtextsupdatedat));
      setClientelingEmailToOptout(rawCustomer[0].csoptinclientelingemails);
      setClientelingEmailUpdatedAt(new Date(rawCustomer[0].csoptinclientelingemailsupdatedat));
      setClientelingExclusionToOptout(rawCustomer[0].csoptinclientelingexclusion);
      setClientelingExclusionUpdatedAt(new Date(rawCustomer[0].csoptinclientelingexclusionupdatedat));

    }       
  }, [sourceEmail, sourcePrimaryPhone, rawCustomer]);

  useEffect(() => {
    if (getPrivacyPreference) {
      setIsCCPAAdminChecked(getPrivacyPreference.enablePrivacyPreferences?? false); // Set invalid if the ticket number is empty
      setFreshServiceTicketNo(getPrivacyPreference.freshServiceTicketNo?? ""); // Set valid if the ticket number is entered
    }
    else {
      setIsCCPAAdminChecked(false); // Set invalid if the ticket number is empty
      setFreshServiceTicketNo(""); // Set valid if the ticket number is entered
    }
  }, [getPrivacyPreference]);

  useEffect(() => {
    let data: ICard[] = [];
    
    for (let i = 0; i < 4; i++) {
      data.push({
        id: i,
        account_no: "1234567890",
        open_date: "05/05",
        tier_status: "Status",
        card_status: "Status",
      });
    }
    setCards(data);

    getCustomerDetail(props.id);
    getPrivacyPreferenceCustomer(props.id);
  }, []);

  const onUpdate = async () => {
		try {
      setFreshServiceTicketNo(freshServiceTicketNo)
      if (!isValid)
      {
        // Check if the checkbox is checked and "SR ticketno" is empty
        setError('The "SR Ticket No" field is required when the checkbox is checked.');
      }
      else {
        if (isCCPAAdminChecked && isCCPAAdmin && !isCCPA)
        {
          setUpdating(true);
          const resPrivacyPreference = await updatePrivacyPreferenceCustomer(privacyPreferenceCustomer);
          setUpdating(false);
        }
        setError('');
        setUpdating(true);
        const res = await updateBulkCustomer({
        customers: rawCustomer.map(rc => {
          return {
            // ...rc,
            aquiaId: customer.mastercustomerid,
            firstname: firstName,
            middlename: middleName,
            lastname: lastName,
            address1: address1,
            address2: address2,
            city: city,
            state: state,
            country: country,
            email: rc.sourceemail,
            zip: zip,
            primaryPhone: rc.sourceprimaryphone,
            status: rc.employeecurrentstatus, // status,
            dob: birthDate || rc.birthdate || '',
            identificationId: identificationId,
            hhId: rc.householdid, // hhId,
            hhHead: hhHead,
            gender: gender,
            contactDirectMail: rc.dmoptout, // based on email selection
            contactDirectMailUpdatedAt: rc.dmlastupdatedt, // based on email selection
            contactEmail: rc.donotemail, // based on email selection
            contactEmailUpdatedAt: contactEmailUpdatedAt,
            contactPhoneCall: rc.calloptout, // based on phone selection
            contactPhoneCallUpdatedAt: rc.calllastupdateddt, // based on phone selection
            contactPhoneText: contactPhoneText,
            contactPhoneTextUpdatedAt: contactPhoneTextUpdatedAt,
            contactFragrance: rc.fragranceoptout, // based on phone selection
            contactFragranceOptionUpdatedAt: rc.fragrancelastupdateddt, // based on phone selection
            ccpaRightToOptout: ccpaRightToOptout,
            ccpaRightToOptoutUpdatedAt: ccpaRightToOptoutUpdatedAt,
            ccpaRightToDelete: ccpaRightToDelete,
            ccpaRightToDeleteUpdatedAt: ccpaRightToDeleteUpdatedAt,
            ccpaRightToKnow: ccpaRightToKnow,
            ccpaRightToKnowUpdatedAt: ccpaRightToKnowUpdatedAt,
            csOptinClientelingTexts:csOptinClientelingTexts,
            csOptinClientelingTextsUpdatedAt:csOptinClientelingTextsUpdatedAt,
            csOptinClientelingEmails:csOptinClientelingEmails,
            csOptinClientelingEmailsUpdatedAt:csOptinClientelingEmailsUpdatedAt,
            csOptinClientelingExclusion:csOptinClientelingExclusion,
            csOptinClientelingExclusionUpdatedAt:csOptinClientelingExclusionUpdatedAt,
            createdAt: null,
            updatedAt: null,
            cbelkDataSource: rc.sourceofdata, // cbelkDataSource
            sourceCustomerNumber: rc.sourcecustomernumber,
            csportalOnlyDataFlag: rc.csportalonlydataflag,
          }
        })
      });
      setUpdating(false);
      if (res.status !== 200) {
        throw new Error();
      } else {
        notify("Successfully update customer data", "success", {
          title: "API Success",
        });
      }
      }
    } catch (error: any) {
      setUpdating(false);
      notify("There's a problem updating customer data.", "error", {
        title: "API Error",
      });
    }
  };

  //Privacy Preferences Admin - Begin
  useEffect(() => {
      if (storedUser) {
        // Parse stored user data
        const parsedUser = JSON.parse(storedUser);
        // Check if "sec_permissions" exists and contains "Update CCPA Admin"
        if (parsedUser["sec_permissions"] && parsedUser["sec_permissions"].includes("Update CCPA Admin")) {
          setIsCCPAAdmin(true);
        } else {
          setIsCCPAAdmin(false);
        }
      }
    }, []); // Empty dependency array means this effect runs once on mount
  
 

  // Privacy Preferences Admin - End

  return (
    <BasicLayout isSpinner={updating || fetching}>
      <div className={!updating && !fetching ? "profile-container" : "profile-container-opacity"}>
        <div className="profile-button">
          <button
            className={
              updating ? "profile-button-back-disabled" : "profile-button-back"
            }
            onClick={() => navigate("/dashboard")}
          >
            <FaArrowLeft style={{ marginRight: "10px" }} /> Back
          </button>
          <button
            className={
              updating
                ? "profile-button-update-disabled"
                : "profile-button-update"
            }
            onClick={() => {
              onUpdate();
            }}
          >
            Update
          </button>
        </div>

        <div className="profile-content">
          <div className="profile-content-detail">
            <Card title="Personal Information">
              <ProfileInput
                title="First Name"
                isAllowed={isPII}
                data={firstName}
                updateData={(val) => setFirstName(val)}
              />
              <ProfileInput
                title="Middle Name"
                isAllowed={isPII}
                data={middleName}
                updateData={(val) => setMiddleName(val)}
              />
              <ProfileInput
                title="Last Name"
                isAllowed={isPII}
                data={lastName}
                updateData={(val) => setLastName(val)}
              />
              <ProfileInput
                title="Address 1"
                placeholder="Street address"
                isAllowed={isPII}
                data={address1}
                updateData={(val) => setAddress1(val)}
              />
              <ProfileInput
                title="Address 2"
                placeholder="Address details(Apt, No, Suite, Block, Etc)"
                isAllowed={isPII}
                data={address2}
                updateData={(val) => setAddress2(val)}
              />
              <ProfileCityState
                city={city}
                state={state}
                isAllowed={isPII}
                updateCity={(val) => setCity(val)}
                updateState={(val) => setState(val)}
              />
              <ProfileInput
                title="Zip Code"
                isAllowed={isPII}
                data={zip}
                updateData={(val) => setZip(val)}
              />
              <ProfileInput
                title="Country"
                isAllowed={isPII}
                data={country}
                updateData={(val) => setCountry(val)}
              />
              <EmailSelect
                title="Email address"
                isAllowed={isPII}
                category_list={rawCustomer.map(r => r.sourceemail)}
                data={sourceEmail}
                onSelect={(val) => {
                  setSourceEmail(`${rawCustomer[val.split(':')[1]].sourceemail}:${val.split(':')[1]}`);
                  setSourcePrimaryPhone(`${rawCustomer[val.split(':')[1]].sourceprimaryphone}:${val.split(':')[1]}`);
                }}
                updateData={(val) => {
                  setRawCustomer(prevRawCustomer => {
                    prevRawCustomer[val.split(':')[1]].sourceemail = val.split(':')[0];
                    return [...prevRawCustomer];
                  });
                }}
              />
              <PhoneSelect
                title="Phone number"
                isAllowed={isPII}
                category_list={rawCustomer.map(r => ({
                  rawValue: r.sourceprimaryphone
                }))}
                data={sourcePrimaryPhone}
                onSelect={(val) => {
                  setSourceEmail(`${rawCustomer[val.split(':')[1]].sourceemail}:${val.split(':')[1]}`);
                  setSourcePrimaryPhone(`${rawCustomer[val.split(':')[1]].sourceprimaryphone}:${val.split(':')[1]}`);
                }}
                updateData={(val) => {
                  setRawCustomer(prevRawCustomer => {
                    prevRawCustomer[val.split(':')[1]].sourceprimaryphone = val.split(':')[0];
                    return [...prevRawCustomer];
                  });
                }}
              />
              <ProfileDatePicker
                title="Birth date"
                isAllowed={isPII}
                data={birthDate}
                updateData={(val) => setBirthDate(val)}
              />
              <ProfileInput
                title="Status"
                isAllowed={false}
                data={status}
                updateData={(val) => setStatus(val)}
              />
              <ProfileInput
                title="Identification ID"
                isAllowed={false}
                data={identificationId}
                updateData={(val) => setIdentificationId(val)}
              />
              <ProfileInput
                title="HH ID"
                isAllowed={false}
                data={hhId}
                updateData={(val) => setHHId(val)}
              />
              <ProfileInput
                title="Head of HH"
                isAllowed={false}
                data={hhHead}
                updateData={(val) => setHeadOfHH(val)}
              />
              <ProfileGender
                isAllowed={false}
                data={gender}
                updateData={(val) => setGender(val)}
              />
              <ProfileInput
                title="Employee Id"
                isAllowed={false}
                data={employeeId}
                updateData={(val) => setEmployeeId(val)}
              />
              <ProfileCust
                title="Synchrony Cust"
                isAllowed={false}
                data={synchronyCustId}
                updateData={(val) => setSynchronyCustId(val)}
              />
              <ProfileCust
                title="Ecommerce Cust"
                isAllowed={false}
                data={ecommerceCustId}
                updateData={(val) => setEcommerceCustId(val)}
              />
            </Card>
          </div>

          <div className="profile-content-detail">
            <Card title="Contact Preferences">
              <div className="profile-content-detail-subheader">
                <span></span>
                <span>Opt Out</span>
                <span>Last Updated On </span>
              </div>

              <ProfileMultiInput
                title="Direct Mail"
                isAllowed={true}
                data={contactDirectMail}
                time={contactDirectMailUpdatedAt}
                updateData={(data) => {
                  setContactDirectMail(data);

                  if (sourceEmail) {
                    setRawCustomer(prevRawCustomer => {
                      prevRawCustomer[sourceEmail.split(':')[1]].dmoptout = data;
                      return [...prevRawCustomer];
                    });
                  }
                }}
                updateTime={(data) => {
                  setContactDirectMailUpdatedAt(data);

                  if (sourceEmail) {
                    setRawCustomer(prevRawCustomer => {
                      prevRawCustomer[sourceEmail.split(':')[1]].dmlastupdatedt = data;
                      return [...prevRawCustomer];
                    });
                  }
                }}
              />
              <ProfileMultiInput
                title="Email"
                isAllowed={false}
                data={contactEmail}
                time={contactEmailUpdatedAt}
                updateData={(data) => {
                  setContactEmail(data);

                  if (sourceEmail) {
                    setRawCustomer(prevRawCustomer => {
                      prevRawCustomer[sourceEmail.split(':')[1]].donotemail = data;
                      return [...prevRawCustomer];
                    });
                  }
                }}
                updateTime={(data) => {
                  setContactEmailUpdatedAt(data);

                  // TBD
                }}
              />
              <ProfileMultiInput
                title="Phone call"
                isAllowed={true}
                data={contactPhoneCall}
                time={contactPhoneCallUpdatedAt}
                updateData={(data) => {
                  setContactPhoneCall(data);

                  if (sourcePrimaryPhone) {
                    setRawCustomer(prevRawCustomer => {
                      prevRawCustomer[sourcePrimaryPhone.split(':')[1]].calloptout = data;
                      return [...prevRawCustomer];
                    });
                  }
                }}
                updateTime={(data) => {
                  setContactPhoneCallUpdatedAt(data);

                  if (sourcePrimaryPhone) {
                    setRawCustomer(prevRawCustomer => {
                      prevRawCustomer[sourcePrimaryPhone.split(':')[1]].calllastupdateddt = data;
                      return [...prevRawCustomer];
                    });
                  }
                }}
              />
              <ProfileMultiInput
                title="Phone text"
                isAllowed={false}
                data={contactPhoneText}
                time={contactPhoneTextUpdatedAt}
                updateData={(data) => {
                  setContactPhoneText(data);

                  // TBD
                }}
                updateTime={(data) => {
                  setContactPhoneTextUpdatedAt(data);

                  // TBD
                }}
              />
              <ProfileMultiInput
                title="Fragrance"
                isAllowed={true}
                data={contactFragrance}
                time={contactFragranceOptionUpdatedAt}
                updateData={(data) => {
                  setContactFragrance(data);

                  if (sourcePrimaryPhone) {
                    setRawCustomer(prevRawCustomer => {
                      prevRawCustomer[sourcePrimaryPhone.split(':')[1]].fragranceoptout = data;
                      return [...prevRawCustomer];
                    });
                  }
                }}
                updateTime={(data) => {
                  setContactFragranceOptionUpdatedAt(data);

                  if (sourcePrimaryPhone) {
                    setRawCustomer(prevRawCustomer => {
                      prevRawCustomer[sourcePrimaryPhone.split(':')[1]].fragrancelastupdateddt = data;
                      return [...prevRawCustomer];
                    });
                  }
                }}
              />
            </Card>
          
            <Card title="Privacy Preferences">
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label htmlFor="ccpaCheckbox" className="checkbox-label" style={{ marginBottom: '0' }} >
                Admin Override
                <input
                  type="checkbox"
                  checked={isCCPAAdminChecked}
                  disabled={!isCCPAAdmin || isCCPA}
		              className={isCCPAAdminChecked ? "input-check" : "input-uncheck"}
                  onChange={handleCheckboxChange}
                />
              </label>
              <label htmlFor="srTickno" style={{ marginBottom: '0' }}>SR Ticket No: </label>
                <input
                  type="text" 
                  id="srTickno"
                  value={freshServiceTicketNo}
                  onChange={handleInputChange} // Update the srTickno state
                  disabled={!isCCPAAdminChecked} // Disable/Enable based on checkbox state
                />  
              </div>
              <div>
                {!hideModifiedDetails && (
                  <div>
                    <ProfileInput
                      title="Modified By"
                      isAllowed={isCCPAAdmin && !isCCPA}
                      data={ccpaAdminModifiedBy}
                      updateData={(val) => setModifiedBy(val)}
                    />
                    <ProfileInput
                        title="Modified Date"
                        isAllowed={isCCPAAdmin && !isCCPA}
                        data={ccpaAdminModefiedDate}
                        updateData={(val) => setModifiedDate(val)}
                    />
                  </div>
                )} 
              </div>
              <div className="profile-content-detail-subheader">
                <span></span>
                <span>Preference</span>
                <span>Last Updated On</span>
              </div>

              <ProfileMultiInput
                title="Right To Optout (Sell)"
                isAllowed={isCCPA || isCCPAAdminChecked}
                data={ccpaRightToOptout}
                time={ccpaRightToOptoutUpdatedAt}
                updateData={(data) => setCCPARightToOptout(data)}
                updateTime={(data) => setCCPARightToOptoutUpdatedAt(data)}
              />
              <ProfileMultiInput
                title="Right To Delete"
                isAllowed={isCCPA || isCCPAAdminChecked}
                data={ccpaRightToDelete}
                time={ccpaRightToDeleteUpdatedAt}
                updateData={(data) => setCCPARightToDelete(data)}
                updateTime={(data) => setCCPARightToDeleteUpdatedAt(data)}
              />
              <ProfileMultiInput
                title="Right To Know"
                isAllowed={isCCPA || isCCPAAdminChecked}
                data={ccpaRightToKnow}
                time={ccpaRightToKnowUpdatedAt}
                updateData={(data) => setCCPARightToKnow(data)}
                updateTime={(data) => setCCPARightToKnowUpdatedAt(data)}
              />
            </Card>

            <Card title="Clienteling">
              <div className="profile-content-detail-subheader">
                <span></span>
                <span>Preference</span>
                <span>Last Updated On</span>
              </div>
              <ProfileMultiInput
                title="Clienteling Text"
                isAllowed={true}
                data={csOptinClientelingTexts}
                time={csOptinClientelingTextsUpdatedAt}
                updateData={(data) => setClientelingTextsToOptout(data)}
                updateTime={(data) => setClientelingTextsUpdatedAt(data)}
              />
              <ProfileMultiInput
                title="Clienteling Email"
                isAllowed={true}
                data={csOptinClientelingEmails}
                time={csOptinClientelingEmailsUpdatedAt}
                updateData={(data) => setClientelingEmailToOptout(data)}
                updateTime={(data) => setClientelingEmailUpdatedAt(data)}
              />
              <ProfileMultiInput
                title="Clienteling Exclusion"
                isAllowed={true}
                data={csOptinClientelingExclusion}
                time={csOptinClientelingExclusionUpdatedAt}
                updateData={(data) => setClientelingExclusionToOptout(data)}
                updateTime={(data) => setClientelingExclusionUpdatedAt(data)}
              />
              
            </Card>

            <Card title="Belk Reward Card">
              <CustomerRewardTable data={rawCustomer.filter(d => d.sourceofdata && d.sourceofdata.toLowerCase() === 'synchrony')} />
            </Card>
          </div>
        </div>
        
        <div className="profile-button">
          <button
            className={
              updating ? "profile-button-back-disabled" : "profile-button-back"
            }
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft style={{ marginRight: "10px" }} /> Back
          </button>

          {error && <div style={{ color: 'red', marginTop: '10px' }}>{error}</div>}

          <button
            className={
              updating ? "profile-button-update-disabled" : "profile-button-update"
            }
            onClick={() => {
              onUpdate();
            }}
          >
            Update
          </button>
        </div>
      </div>
    </BasicLayout>
  );
};
